import { useEffect, useState } from 'react';
import { useChatClient } from '@bizzabo/chat-core';
import { useSessionChatNotification } from '@bizzabo/session-chat';
import useQnaNotification from '../../Qna/decorators/useQnaNotification';
import { IAppNotification, INotificationParams } from '../../../tools/types/appTools';

const useEngagementPanelNotification = ({
    eventUniqueName,
}: INotificationParams): IAppNotification => {
    const [hasNewNotification, setHasNewNotification] = useState<boolean>(false);

    const { client } = useChatClient();
    const { hasNewChatNotification, resetChatNotification } = useSessionChatNotification(client);
    const { hasNewQnaNotification, resetQnaNotification } = useQnaNotification(eventUniqueName);

    useEffect(() => {
        if (hasNewChatNotification || hasNewQnaNotification) {
            setHasNewNotification(true);
        }
    }, [hasNewChatNotification, hasNewQnaNotification]);

    const resetNotification = () => {
        resetQnaNotification();
        resetChatNotification();
        setHasNewNotification(false);
    };

    return { hasNewNotification, resetNotification, shouldResetNotificationOnSelect: true };
};

export default useEngagementPanelNotification;
